import { render, staticRenderFns } from "./PoliciesModal.vue?vue&type=template&id=7afe0580&"
import script from "./PoliciesModal.vue?vue&type=script&lang=js&"
export * from "./PoliciesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports